document.addEventListener('DOMContentLoaded', () => {
  const swatchGroups = document.querySelectorAll('.drim-card-swatches');

  swatchGroups.forEach((swatchGroup) => {
    const productCard = swatchGroup.closest('.card-wrapper');

    if (!productCard) return;

    const productImage = productCard.querySelector('.card__media img');

    if (!productImage) return;

    const originalImage = {
      src: productImage.getAttribute('src'),
      srcset: productImage.getAttribute('srcset'),
      sizes: productImage.getAttribute('sizes')
    };

    const showVariantImage = (swatch) => {
      const variantImage = swatch.dataset.drimImage;

      if (!variantImage) return;

      productImage.setAttribute('src', variantImage);
      productImage.setAttribute('srcset', variantImage);
    };

    const restoreOriginalImage = () => {
      if (originalImage.src) {
        productImage.setAttribute('src', originalImage.src);
      }

      if (originalImage.srcset) {
        productImage.setAttribute('srcset', originalImage.srcset);
      } else {
        productImage.removeAttribute('srcset');
      }

      if (originalImage.sizes) {
        productImage.setAttribute('sizes', originalImage.sizes);
      }
    };

    swatchGroup
      .querySelectorAll('.drim-card-swatch[data-drim-image]')
      .forEach((swatch) => {
        swatch.addEventListener('mouseenter', () => {
          showVariantImage(swatch);
        });

        swatch.addEventListener('focus', () => {
          showVariantImage(swatch);
        });
      });

    swatchGroup.addEventListener('mouseleave', restoreOriginalImage);

    swatchGroup.addEventListener('focusout', (event) => {
      if (!swatchGroup.contains(event.relatedTarget)) {
        restoreOriginalImage();
      }
    });
  });
});